import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

(async () => {
  try {
    if (!customElements.get('vsn-navigation')) {
      await import('@visma-swno/vsn-navigation');
    }

    await bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]});
  } catch (err) {
    console.error('Failed to initialize application.', err);
    throw err;
  }
})().catch(() => undefined);
